define('views/modules/calendar/nutrition/nutrient/list/nutrient-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',

    // events
    'services/events/nutrition-events',

    // services
    'services/i18n',

    // templates
    'text!templates/modules/calendar/nutrition/nutrient/list/nutrient-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, U,

    // events
    NutritionEvents,

    // services
    i18n,

    // templates
    TNutrientListItem
) {

    var VNutrientListItem = Backbone.View.extend({
        template: TNutrientListItem,
        className: "macro-element urowfix",
        render: function() {
            var model = this.model,
                data = _.extend({
                    translatedName: i18n.t(model.get('trName')),
                    roundedValue: _.roundTo(model.getValue(), 1),
                    percent: Math.min(model.getPercent(this.collection.getMacroTotal()), 100),
                    status: model.getStatus(),
                    bar: !model.is('calories') && (model.isMacro() || Boolean(model.get('recommended')))
                }, model.toJSON());
            this.$el.empty().append(Mustache.render(this.template, data));
            return this;
        },

    });

    return VNutrientListItem;

});

